import { useTranslation } from "@hireroo/i18n";
import { TagForm } from "@hireroo/validator";
import { zodResolver } from "@hookform/resolvers/zod";
import * as React from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";

import DialogWithCloseIcon, { DialogWithCloseIconProps } from "../../primitive/DialogWithCloseIcon/DialogWithCloseIcon";

export type TagDialogProps = {
  TagField: React.ReactNode;
  onSubmit: SubmitHandler<TagForm.TagsSchema>;
  defaultValues: TagForm.TagsSchema;
  disabled?: boolean;
  open: boolean;
  onOpen?: () => void;
  onClose?: DialogWithCloseIconProps["onClose"];
};

const TagDialog: React.FC<TagDialogProps> = props => {
  const { t } = useTranslation();
  const validateSchema = TagForm.useTagsFormSchema();
  const methods = useForm<TagForm.TagsSchema>({
    resolver: zodResolver(validateSchema),
    defaultValues: props.defaultValues,
    mode: "onSubmit",
  });

  const tagDialog: DialogWithCloseIconProps = {
    open: props.open,
    title: t("タグの編集"),
    onClose: () => {
      props.onClose?.();
    },
    noButton: {
      onClick: () => {
        props.onClose?.();
      },
      color: "secondary",
      children: t("キャンセル"),
    },
    disableEnter: true,
    yesButton: {
      onClick: () => {
        methods.handleSubmit(props.onSubmit)();
      },
      color: "secondary",
      children: t("保存"),
    },
  };

  return (
    <DialogWithCloseIcon key="tag-dialog" {...tagDialog}>
      <FormProvider {...methods}>{props.TagField}</FormProvider>
    </DialogWithCloseIcon>
  );
};

TagDialog.displayName = "TagDialog";

export default TagDialog;
